import React, { useState } from 'react';
import Footer from './Footer';
import emailjs from 'emailjs-com';
import CInputText from './controls/CInputText';
import CSTextArea from './controls/CSTextArea';
import classNames from 'classnames';

const SERVICE_ID = "service_zqyv4xl";
const TEMPLATE_ID = "template_0fnomnk";
const PUBLIC_KEY = "2IW2VzxvpLkVBXqZo";

export default function Contact2() {

  const [mName, setName] = useState('');
  const [mEmail, setMail] = useState('');
  const [mMessage, setMessage] = useState('');

  const handleOnSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, PUBLIC_KEY)
      .then((result) => {
        console.log(result.text);
        alert('Message Sent Successfully')
      }, (error) => {
        console.log(error.text);
        alert('Something went wrong!')
      });
    e.target.reset()
  };

  return (
        <div
          className={classNames('flex flex-column', {
            'fullHeight': window.innerWidth >= 640, 
            'fullHeightmb': window.innerWidth < 640, 
          })}
        >
      <div className="text-center py-4 sm:py-2">
        <div className="text-3xl font-bold text-primary">Contact Us</div>
        <div className="csunderline "></div>
      </div>

      <div className="mx-4 my-2 p-3 bg-white shadow-lg rounded-lg flex flex-wrap justify-between">
        <div className="col-12 lg:col-6 px-4">
          <form className="formContainer" onSubmit={handleOnSubmit}>
            <CInputText
              mvalue={mName}
              pOnChange={setName}
              placeholder={' '}
              pName={'from_name'}
              ptype={'text'}
              pLabel={'Name'}
              pLabelId='from_name'
              padding='0.75rem'
              marginBottom='12px'
              pRequired={true}
              pClassName={'mb-4'}
            />

            <CInputText
              mvalue={mEmail}
              pOnChange={setMail}
              placeholder={' '}
              pName={'from_email'}
              ptype={'email'}
              pLabel={'Email'}
              pLabelId='from_email'
              padding='0.75rem'
              marginBottom='12px'
              pRequired={true}
              pClassName={'mb-4'}
            />

            <CSTextArea
              mvalue={mMessage}
              pOnChange={setMessage}
              placeholder={''}
              pName={'message'}
              pLabel={'Message'}
              pLabelId='Message'
              padding='0.75rem'
              marginBottom='12px'
              height='150px'
            />

            <button
              type='submit'
              style={{
                backgroundColor: '#108040',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                width: '100%',
                maxWidth: '200px',
                marginTop: '16px',
              }}
            >
              Submit
            </button>
          </form>
        </div>

        <div className="col-12 lg:col-6 mt-8 lg:mt-0">

          <div className="contact-info">
            <div className="contact-item mb-4 pt-4">
              <a href="tel:+919032849685" className="text-lg font-semibold text-primary flex items-center">
                <i className="pi pi-whatsapp mr-2"></i>
                <span>+91-9032849685</span>
              </a>
            </div>
            <div className="contact-item mb-4">
              <h3 className="text-lg font-semibold text-primary flex items-center">
                <i className="pi pi-inbox mr-2"></i><span>ask@chinmmaisys.com</span>
              </h3>
            </div>
            <div className="contact-item">
              <h3 className="text-lg font-semibold text-primary flex items-center">
                <i className="pi pi-directions mr-2"></i><span>Hyderabad, Telangana, India.</span>
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  );
}
